import restClient from 'Shared/hooks/restClient'
import BackdropModal from 'Shared/components/BackdropModal/BackdropModal'
import Wizard from 'Campaigns/CreateCampaign/components/Wizard'
import CollapsibleCardList from 'Shared/components/CollapsibleCardList/CollapsibleCardList'
import './QuickSearches.scoped.scss'
import Search from './Search'
import SupportCard from './SupportCard'

export default function QuickSearches({ create = false, edit = false, compact = false }) {
  const [loaded, setLoaded] = useState(false)
  const [searches, setSearches] = useState([])
  const [chosenSearchId, setChosenSearchId] = useState(null)
  const act = useAct()

  // Load
  useEffect(() => {
    restClient.get('/api/searches/templates').then(({ data }) => {
      setSearches(data)
      setLoaded(true)
    })
  }, [])

  const newCampaign = (searchId) => {
    act.createCampaign.reset()
    setChosenSearchId(searchId)
  }

  const useSearch = (searchId) => {
    restClient.post(`/api/searches/${searchId}/clone?use_search=y`).then(({ data }) => {
      window.location = data.redirectUrl
    })
  }

  if (!loaded) return <div />

  return (
    <div className={`quick-searches-${compact ? 'compact box' : 'normal'}`}>
      <CollapsibleCardList
        initialLimit={compact ? 8 : searches.length + 1}
        singleRow={!compact}
      >
        {searches.map((s) => (
          <Search
            {...s}
            key={s.id}
            newCampaign={newCampaign}
            useSearch={useSearch}
            edit={edit}
            compact={compact}
          />
        ))}
        {!compact && <SupportCard create={create && searches.length === 0} />}
      </CollapsibleCardList>

      {chosenSearchId && (
        <Modal
          key={chosenSearchId}
          searchId={chosenSearchId}
          close={() => setChosenSearchId(null)}
        />
      )}

      {searches.length === 0 && compact && (
        <div>
          <p className="no-margin-top bold">
            You don't have any quick start audiences yet.
          </p>
          <div className="tip">
            <div className="icon">
              <SvgIconsTip />
            </div>
            <p>
              Quick start audiences are commonly used audiences, which you can quickly
              start campaigns from. You can make an audience a quick start audience when
              you create or edit it.
            </p>
          </div>
        </div>
      )}
    </div>
  )
}

function Modal({ searchId, close }) {
  return (
    <BackdropModal title="Create a new campaign" open={true} onCancel={close}>
      <Wizard searchId={searchId} cloneSearchId={searchId} />
    </BackdropModal>
  )
}
